function formatRupiah(amount) {
  // Ensure the input is a number
  if (typeof amount !== "number") {
    return "Invalid input"; // Or throw an error, depending on desired behavior
  }

  // Convert to string and handle potential decimal values
  let parts = amount.toFixed(0).toString().split("."); // Format to 0 decimal places for Rupiah

  // Add thousand separators
  let rupiah = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  // Return formatted string
  return `Rp ${rupiah}`;
}

export default formatRupiah;
